import MessageThreadInput from './MessageThreadInput';

export default MessageThreadInput;
